import { Vision } from '@wizeoo/akm-message-lib';
import { VisionVO } from '../../vo/vision/vision.vo';
import { Model } from '../../model/model';
import { WizConstants } from '../../model/constants';

/**
 * Manager des visions.
 * Contient toutes les visions chargées pour le périmètre de l'utilisateur
 */
export class VisionEngine {

    protected _model: Model;
    constructor(pmodel: Model) {
        this._model = pmodel;
    }

    public get model(): Model {
        return this._model as Model;
    }

    /* ################################################
        le constructeur (pour obtenir le bon type)
    ################################################ */

    public newVisionVO(source: Vision): VisionVO {
        return new VisionVO(source);
    }

    public feedVisionEntities(entities: Vision[]) {
        const visions: VisionVO[] = entities.map((vision) => this.newVisionVO(vision)); // liste brute
        this.feedVisions(visions);
    }

    /** alimentation des visions du modèle sur find */
    public feedVisions(vos: VisionVO[]): void {
        const existVision: VisionVO[] = this.model.visions || [];
        const existMap: Map<string, VisionVO> = new Map(existVision.map(v => [this.getVisionUniqueKey(v), v]));
        vos.forEach(v => { // on écrase
            existMap.set(this.getVisionUniqueKey(v), v);
        })

        this.model.visions = [...existMap.values()];

        // génération du dico
        const newDic: Map<string, Map<string, VisionVO>> = new Map<string, Map<string, VisionVO>>();
        [...existMap.values()].forEach((vis: VisionVO) => {
            if (!newDic.has(vis.businessUnitCode)) {
                newDic.set(vis.businessUnitCode, new Map<string, VisionVO>());
            }
            newDic.get(vis.businessUnitCode).set(vis.code, vis);
        });
        this.model.visionsDic = newDic;
    }

    /** génération de la clé unique de la vision */
    public getVisionUniqueKey(vision: VisionVO): string {
        return vision.domain + WizConstants.KEY_SEPARATOR + vision.businessUnitCode + WizConstants.KEY_SEPARATOR + vision.code;
    }

    /**
   * Récupération de la map de vision de la bu
   *
   * @param pCode Le code de la vidion recherchée
   */
    public getBuVisionMap(): Map<string, VisionVO> {
        if (this.model.visionsDic != null) {
            const buMap: Map<string, VisionVO> = this.model.visionsDic.get(this.model.businessUnitCode);
            if (buMap) {
                return buMap;
            }
        }
        return null;
    }

    /**
     * Récupération de la vision associée au code donné si elle existe, null sinon
     *
     * @param pCode Le code de la vision recherchée
     */
    public getVision(pCode: string): VisionVO {
        if (this.getBuVisionMap()) {
            return this.getBuVisionMap().get(pCode);
        }
        return null;
    }

}